mutation TripDelete($input: TripDeleteInput!, $id: UUID!) {
  tripDelete(input: $input) {
    query {
      travelAuthorization(id: $id) {
        __typename
        id
        _rowTimestamp
        _travelerReference
        budgetAmount
        controlTotalAmount
        _requiredApprovalDocuments
        notesByEntityId(orderBy: _CREATED_DATE_DESC) {
          nodes {
            id
            _createdByUserName
            _createdDate
            noteComment
            isShared
            _isUpdatable
            _rowTimestamp
            _isDeletable
          }
        }
        trips(orderBy: [TRAVELER_REFERENCE_NAME_ASC, TRIP_LOCATOR_ASC]) {
          nodes {
            id
            tripLocator
            travelerReferenceName
            accountReference
            airfareAmount
            accommodationAmount
            transportationAmount
            vehicleRentalAmount
            trainAmount
            otherAmount
            controlTotalAmount
            _isOverBudget
            budgetAmount
          }
        }
      }
    }
  }
}
